import * as Yup from "yup";
import { requiredTextFieldMin, requiredTextFieldMinMax } from "./commonValidationSchemas";
import awesomeDebouncePromise from "awesome-debounce-promise";
import packsDataService from "../../features/Licensing/Packs/services/packsDataService";
import { PricingTypes } from "enums/licensing/pricingTypes";

const debounceTimeMs = 500;

const isTitleUnique = awesomeDebouncePromise(packsDataService.isTitleUniqueAsync, debounceTimeMs);

const thumbnailUrl = (): Yup.StringSchema<string | undefined, object> =>
  Yup.string().trim().required("Thumbnail Image is required");
const title = (titleInitialValue?: string) =>
  requiredTextFieldMinMax("Title", 3, 64).test("unique-title", "Pack Title should be unique", (value, context) => {
    if (value && value !== titleInitialValue) {
      return isTitleUnique(value, context.parent.id);
    }

    return true;
  });

const longDescription = (longDescriptionInitialValue?: string) =>
  requiredTextFieldMin("Long Description", 100)
    .max(15000, `Long Description cannot exceed 15,000 characters`)
    .default(longDescriptionInitialValue);

export const packConfigure = (titleInitialValue?: string, longDescriptionInitialValue?: string) =>
  Yup.object().shape({
    title: title(titleInitialValue),
    description: requiredTextFieldMinMax("Short Description", 3, 255),
    longDescription: longDescription(longDescriptionInitialValue),
    thumbnailImageUrl: thumbnailUrl(),
  });

export const packSettings = Yup.object().shape({
  pricingSettings: Yup.object().shape({
    pricePerUser: Yup.number()
      .nullable()
      .test("required-if-paid", "Price must be greater than 0 for paid packs", function (value) {
        return (
          this.from![1].value.pricingTypeId !== PricingTypes.Paid ||
          (value !== undefined && value !== null && value > 0)
        );
      }),
    billingTermId: Yup.number()
      .nullable()
      .test("required-if-paid", "Billing term is required for paid packs", function (value) {
        return (
          this.from![1].value.pricingTypeId !== PricingTypes.Paid ||
          (value !== undefined && value !== null && value > 0)
        );
      }),
    trialPeriodId: Yup.number()
      .nullable()
      .test("required-if-trial", "Trial period is required when trial is allowed for paid pack", function (value) {
        return (
          this.from![1].value.pricingTypeId !== PricingTypes.Paid ||
          !this.parent.isTrialAllowed ||
          (value !== undefined && value !== null && value > 0)
        );
      }),
  }),
});
